import Vuex from 'vuex'
import Vue from 'vue'

import auth from './modules/auth';
import foxes from './modules/foxes';
import poi from './modules/poi';
import users from './modules/users';
import cars from './modules/cars';
import groups from './modules/groups';
import settings from './modules/settings';

Vue.use(Vuex);

const AUTH_LOGIN = 'AUTH_LOGIN';
const AUTH_LOGIN_SUCCESS = 'AUTH_LOGIN_SUCCESS';
const AUTH_SET_USER = 'AUTH_SET_USER';

const store = new Vuex.Store({
    modules: {
        auth,
        foxes,
        poi,
        users,
        cars,
        groups,
        settings
    }
});

export default store;


// WEBPACK FOOTER //
// ./src/store/index.js